export const defaultErrorMessages = {
  GET: 'No se pueden cargar los datos. Por favor, inténtelo de nuevo más tarde.',
  POST: 'No fue posible procesar la solicitud.',
  PUT: 'Los datos no se han podido actualizar',
  DELETE: 'No fue posible eliminar el registro.',
  expiredToken: 'La sesión expiró. Por favor, intente iniciar sesión de nuevo.',
  defaultMessage: 'Algo ha salido mal.',
  FORBIDDEN: 'No tienes permisos suficeentes para acceder a esta parte, contactate con el administrador del sistema.'
};

export const displayErrorMessage = (errorToast) => (e, requestType, customMessage = null) => {
  const errorResponse = e?.response?.data;
  if (errorResponse?.statusCode === 401) {
    return errorToast(defaultErrorMessages.expiredToken);
  }
  if (errorResponse?.statusCode === 403) {
    return errorToast(defaultErrorMessages.FORBIDDEN);
  }

  let id;
  try {
    id = (JSON.parse(errorResponse?.message) || {}).id;
  } catch (error) {
    id = 'Unknown Error';
  }

  const errorMessage = customMessage
    || (requestType ? defaultErrorMessages[requestType] : defaultErrorMessages.defaultMessage);
  errorToast(errorMessage, id);
};
